import { v } from "convex/values";
import { defineTable } from "convex/server";

export const validatorUserInvitation = v.object({
  userId: v.id("users"),
  token: v.string(),
  expiresAt: v.number(),
  used: v.boolean(),
  usedAt: v.optional(v.number()),
  createdBy: v.id("users"),
  createdAt: v.number(),
});

export const user_invitations = defineTable(validatorUserInvitation)
  .index("by_token", ["token"])
  .index("by_user_id", ["userId"])
  .index("by_created_by", ["createdBy"])
  .index("by_expires_at", ["expiresAt"]);
